import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import "./style/EditProduct.css";

export default function EditProduct() {
    const { productslug } = useParams();
    
     const api = "https://mkbackend-production.up.railway.app"
   const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        price: '',
        description: '',
        image: null
    });
    const [currentImage, setCurrentImage] = useState('');

    useEffect(() => {
        fetchProduct();
    }, [productslug]);

    const fetchProduct = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem('token');
            const res = await axios.get(`${api}/product/${productslug}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            if (res.data.success) {
                const product = res.data.product;
                setFormData({
                    name: product.name || '',
                    price: product.price || '',
                    description: product.description || ''
                });
                setCurrentImage(product.image || '');
            }
        } catch (error) {
            console.error('Error fetching product:', error);
            setError('Failed to load product');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        setFormData(prev => ({
            ...prev,
            image: e.target.files[0]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            setSaving(true);
            const token = localStorage.getItem('token');
            
            const data = new FormData();
            data.append('name', formData.name);
            data.append('price', formData.price);
            data.append('description', formData.description);
            if (formData.image) {
                data.append('image', formData.image);
            }
            
            const res = await axios.put(
                `${api}/edit-product/${productslug}`,
                data,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            
            if (res.data.success) {
                // Show success message
                const toast = document.createElement('div');
                toast.className = 'toast success';
                toast.textContent = '✅ Product updated successfully!';
                document.body.appendChild(toast);
                setTimeout(() => toast.remove(), 3000);
                
                navigate('/allproducts');
            }
        } catch (error) {
            console.error('Error updating product:', error);
            setError(error.response?.data?.message || 'Failed to update product');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Loading product...</p>
            </div>
        );
    }

    return (
        <div className="edit-product-container">
            <div className="edit-product-card">
                <h2>Edit Product</h2>
                
                {error && (
                    <div className="error-message">
                        ❌ {error}
                    </div>
                )}
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Product Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Enter product name"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Price (PKR)</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            required
                            placeholder="Enter price"
                            step="0.01"
                            min="0"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            placeholder="Enter product description"
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Current Image</label>
                        {currentImage && (
                            <div className="current-image">
                                <img src={currentImage} alt="Current product" />
                            </div>
                        )}
                    </div>
                    
                    <div className="form-group">
                        <label>Upload New Image (Optional)</label>
                        <input
                            type="file"
                            name="image"
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                    </div>
                    
                    <div className="form-actions">
                        <button 
                            type="button" 
                            className="cancel-btn"
                            onClick={() => navigate('/allproducts')}
                        >
                            Cancel
                        </button>
                        <button 
                            type="submit" 
                            className="save-btn"
                            disabled={saving}
                        >
                            {saving ? 'Saving...' : '💾 Save Changes'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}